var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconoCotizaciones(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.431,
    height: 16.118,
    viewBox: "0 0 13.431 16.118",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_30973",
    "data-name": "Trazado 30973",
    d: "M258.734,337.69l-2.34-2.341a4.675,4.675,0,0,0-3.324-1.377h-3.032a3.362,3.362,0,0,0-3.358,3.358v9.4a3.362,3.362,0,0,0,3.358,3.358h6.715a3.362,3.362,0,0,0,3.358-3.358v-5.718A4.669,4.669,0,0,0,258.734,337.69Zm-.95.95a3.35,3.35,0,0,1,.525.7h-2.9a.671.671,0,0,1-.672-.671v-2.9a3.329,3.329,0,0,1,.706.524Zm.984,8.093a2.015,2.015,0,0,1-2.015,2.015h-6.715a2.015,2.015,0,0,1-2.015-2.015v-9.4a2.015,2.015,0,0,1,2.015-2.015h3.032c.11,0,.217.021.325.031v3.327a2.015,2.015,0,0,0,2.015,2.015h3.326c.01.109.032.215.032.326Z",
    transform: "translate(-246.68 -333.972)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoCotizaciones);
export default __webpack_public_path__ + "static/media/Icono-Cotizaciones.1a4d3ae32f51c0340d3a4cbad282d956.svg";
export { ForwardRef as ReactComponent };